import { S3_PATH } from '@fitpet/constants-global'
import { Image } from '@/components/common/images/Image'
import { FitpetTitleHeader } from '@/components/domains/layouts/header/fitpet-title-header'
import { FITPET } from '@/constants/legacy/constData'

const paymentGuaranteeImageSrc = `${
  S3_PATH[process.env.NEXT_PUBLIC_ENVIRONMENT]
}/policy/tosspayment-purchase-safety-service-2025-06-17.png`

const PagePolicyPaymentGuarantee = () => {
  return (
    <>
      <FitpetTitleHeader title={FITPET.PURCHASE_SAFETY_SERVICE} />
      <Image alt={FITPET.PURCHASE_SAFETY_SERVICE} src={paymentGuaranteeImageSrc} />
    </>
  )
}

export default PagePolicyPaymentGuarantee
